
import { FacebookShareButton, RedditShareButton, XShareButton } from "react-share";
import { faDiscord, faXTwitter, faRedditAlien } from '@fortawesome/free-brands-svg-icons';
import socialLogos from '../../images/social_icons';

const socialIcons = [{
    platform: 'reddit',
    label: 'Reddit',
    icon: faRedditAlien,
    color: '#FF4500',
    url: 'https://www.reddit.com/r/SpitfaceBattles/'
  }, {
    platform: 'x',
    label: 'X',
    icon: faXTwitter,
    color: '#e7e9ea',
    url: 'https://x.com/SpitfaceBattles/',
  }, {
    platform: 'discord',
    label: 'Discord',
    icon: faDiscord,
    color: '#5865f2',
    url: 'https://discord.gg/yRTP6aD5rf'
  }];

export const sharePlatforms = [{
  platform: 'x',
  label: 'X',
  logo: socialLogos.x,
  color: '#e7e9ea',
  SocialShareButton: XShareButton
}, {
  platform: 'reddit',
  label: 'Reddit',
  logo: socialLogos.reddit,
  color: '#FF4500',
  SocialShareButton: RedditShareButton
}, {
  platform: 'facebook',
  label: 'Facebook',
  logo: socialLogos.facebook,
  color: '#1877F2',
  SocialShareButton: FacebookShareButton
}];

  export default socialIcons
